import gql from 'graphql-tag';
import { graphql, ChildDataProps } from 'react-apollo';
import { get } from 'lodash';
import {
  IProps as ICheckoutPaymentSelectionContinueButtonProps,
} from './checkout_payment_selection_continue_button';

import {
  SelectableCreditCardListQuery,
} from '../schemas/rql';

/* eslint-disable */
export const QUERY = gql`
query SelectableCreditCardListQuery {
  me {
    uuid
    creditCards {
      id
      last4
      cardType
      expirationYear
      expirationMonth
      cardholderName
      needsReverification
      primaryForCheckout
      # this client side field is defined locally and not
      # in the intropsection schema, which is why we're
      # turning the linting off
      isSelected @client
    }
  }
}`;
/* eslint-enable */

export type ChildProps = ChildDataProps<{}, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables>;
export const connectCheckoutButtonQuery = graphql<ICheckoutPaymentSelectionContinueButtonProps, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables, ChildProps>(
  QUERY,
  {
    skip: ownProps => !!get(ownProps.user, 'loggedOut', true),
  },
);
export const connectSelectableCreditCardListQuery = graphql<{}, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables>(QUERY);

export function selectCard(_, { id }, { client }) {
  const updated = updateQueryDataInline(client.readQuery({ query: QUERY }), id);
  client.writeQuery({ query: QUERY, data: updated });
  return null;
}

export function updateQueryDataInline(originalQueryData, id) {
  const updated = { ...originalQueryData };
  updated.me.creditCards = originalQueryData.me.creditCards.map((cc) => {
    if (cc.id === id) {
      return { ...cc, isSelected: true };
    }
    return { ...cc, isSelected: false };
  });
  return updated;
}

export const resolvers = {
  core_apimessages_CreditCard: {
    isSelected: (cc) => {
      return cc.primaryForCheckout;
    },
  },
};
